import { Callback } from '../../types/helpers';
import './style.scss';

type CloseIconProps = Partial<{
  onClick: Callback;
}>;

export const CloseIcon = ({ onClick }: CloseIconProps) => <div onClick={onClick} className='close-icon' />;
